import { render, staticRenderFns } from "./DynamicFormList.vue?vue&type=template&id=58f09928"
import script from "./DynamicFormList.vue?vue&type=script&lang=js"
export * from "./DynamicFormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports